import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08743a9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bags-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Button, {
      class: "bag-button",
      type: "button",
      color: "white",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addBag('small')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SvgIcon, {
          class: "bag-icon-small",
          type: "mdi",
          path: _ctx.bagIcon
        }, null, 8, ["path"])
      ]),
      _: 1
    }),
    _createVNode(_component_Button, {
      class: "bag-button",
      type: "button",
      color: "white",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addBag('medium')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SvgIcon, {
          class: "bag-icon-medium",
          type: "mdi",
          path: _ctx.bagIcon
        }, null, 8, ["path"])
      ]),
      _: 1
    }),
    _createVNode(_component_Button, {
      class: "bag-button",
      type: "button",
      color: "white",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addBag('large')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SvgIcon, {
          class: "bag-icon-large",
          type: "mdi",
          path: _ctx.bagIcon
        }, null, 8, ["path"])
      ]),
      _: 1
    })
  ]))
}